<script>
import md5 from "md5";

var ajaxUrl = "http://api-edu.live.360.cn";
var host = document.location.hostname;
if (
  host == "lr.eduplatform.zyun.360.cn" ||
  host == "test.admin-edu.zyun.360.cn"
) {
  ajaxUrl = "http://10.220.168.209:9071";
}

var isJumpingToLogin = false;
var userInfo = null;

const ajaxAdd = {
  getList: "/CourseiSession/getCourseList",
  devicePlay: "/Device/play",
  devicePlayNew: "/Device/playNew",
  checkUser: "/User/checkUser",
  getRecordList: "/CourseiSession/getCourseQvodList",
  recordPlay: "/Device/getQvodUrl",
  upInfo: "/Student/upInfo",
  getSchoolList: "/School/getList",
  heartBeat: "/Student/heartBeat",
  playLink: "/Device/playLink", // 根据播放连接获取帝视开流信息
  studentLeave: "/Student/leave", // 学生请假
};
function setCookie (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
//获取cookie
function getCookie (cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) != -1) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
//清除cookie
function clearCookie () {
  setCookie("username", "", -1);
}
function checkCookie () {
  var user = getCookie("username");
  if (user != "") {
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}

/*
target:jquery的拖拽目标class或id
panel：panel的jquery对象
left、top：panel的偏移坐标
*/
function movePanel (target, panel, left, top) {
  console.log(panel);
  $(document).off("mousedown", target);
  $(document).on("mousedown", target, function (e) {
    e.stopPropagation();
    var pos = getMousePosition(e, panel);
    var l = e.pageX - pos.x + left;
    var t = e.pageY - pos.y + top;
    panel.css({
      left: l + "px",
      top: t + "px",
    });
    $(document).on("mouseup", (e) => {
      $(document).off("mouseup");
      $(document).off("mousemove");
    });
    $(document).on("mousemove", (e) => {
      e.stopPropagation();
      var l = e.pageX - pos.x + left;
      var t = e.pageY - pos.y + top;
      if (t < top) {
        t = top;
      }
      panel.css({
        left: l + "px",
        top: t + "px",
      });
    });
  });
}

//拖拽移动时，需要获取一个相对坐标，用于标记鼠标落下在目标内部时的哪个点
function getMousePosition (e, middle) {
  //获取div中鼠标的相对坐标
  var posX = 0;
  var posY = 0;
  var conX = middle.offset().left;
  var conY = middle.offset().top;
  var event = event || window.event;
  if (event.pageX || event.pageY) {
    posX = event.pageX;
    posY = event.pageY;
  } else if (event.clientX || event.clientY) {
    posX =
      event.clientX +
      document.documentElement.scrollLeft +
      document.body.scrollLeft;
    posY =
      event.clientY +
      document.documentElement.scrollTop +
      document.body.scrollTop;
  }
  return { x: posX - conX, y: posY - conY };
}

function rem2Px (rem) {
  return (rem * 100 * document.documentElement.clientWidth) / 750;
}

function px2Rem (px) {
  return (0.01 * px * 750) / document.documentElement.clientWidth;
}
var menuInfo = [
  { index: 0, path: "device", name: "直播课", icon: "video-camera" },
  { index: 1, path: "record", name: "回放课", icon: "history" },
];

function getMenuIndex (path) {
  for (var i = 0; i < menuInfo.length; i++) {
    if (menuInfo[i].path == path || "/" + menuInfo[i].path == path) {
      return menuInfo[i].index;
    }
  }
  return 0;
}

export default {
  menuInfo,
  getMenuIndex,
  ajaxUrl,
  ajaxAdd,
  isJumpingToLogin,
  userInfo,
  setCookie,
  getCookie,
  clearCookie,
  checkCookie,
  getMousePosition,
  movePanel,
};
</script>



// WEBPACK FOOTER //
// src/components/utils/Global.vue